/* eslint-disable jsx-a11y/media-has-caption */
import * as ShowMediaModal from '@/app/store/actions';
import Dialog from '@material-ui/core/Dialog';
import Close from '@material-ui/icons/Close';
import makeStyles from '@material-ui/styles/makeStyles';
import React from 'react';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(() => ({
	backDrop: {
		backdropFilter: 'blur(10px)',
		backgroundColor: 'rgba(0,0,30,0.4)',
	},
}));
const OnlyMediaComponent = ({ media }) => {
	const [pictureLarge, setPictureLarge] = React.useState(null);
	const classes = useStyles();
	const dispatch = useDispatch();
	console.log('sup');

	return (
		<>
			{pictureLarge ? (
				<Dialog
					BackdropProps={{
						classes: {
							root: classes.backDrop,
						},
					}}
					onClose={() => {
						setPictureLarge(null);
					}}
					open={pictureLarge}
				>
					<div className="larg_image flex flex-col">
						<button
							className="self-end cursor-pointer absolute profile-close"
							onClick={() => setPictureLarge(null)}
							type="button"
						>
							<Close />
						</button>
						<img alt="large" src={pictureLarge} />
					</div>
				</Dialog>
			) : null}
			<div className="bg-white images-popup">
				<div className="flex justify-between images-popup-header">
					<div />
					<button
						onClick={() => dispatch(ShowMediaModal.closeMediaDialog())}
						style={{ cursor: 'pointer' }}
						type="button"
					>
						<i className="fas text-[20px]" />
					</button>
				</div>
				<div className="media-list-cont w-full" id="scrollable-list">
					{media.map((item, index) => {
						return (
							<div className="flex-1" key={index}>
								{item.type === 'image' ? (
									<button
										onClick={() => {
											setPictureLarge(item.link);
										}}
										style={{
											margin: '16px 0',
											width: '100%',
											height: 300,
											background: 'black',
											padding: 0,
											border: 'none',
										}}
										type="button"
									>
										<img
											alt=""
											src={item.link}
											style={{
												width: '100%',
												height: '100%',
												objectFit: 'contain',
											}}
										/>
									</button>
								) : (
									<video
										controls
										poster={item.thumb}
										src={item.link}
										style={{
											margin: '16px 0px',
											width: '100%',
											height: 300,
											objectFit: 'contain',
											backgroundColor: 'black',
										}}
									/>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default OnlyMediaComponent;
